import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { ErrorBoundary } from '@grc/ui-package';
import { I18nProvider } from './stores/settings/language-context';
import Layout from './pages/layout';
import { SettingsMenuProvider } from './contexts/settings/setting-menu-header-context';
import { useCustomerPortalGlobalStore } from './stores/customer-portal-global-store';
import { OrderProvider } from './stores/create-order/order-store';
import { BolOrderProvider } from './stores/create-order/order-store-bol';
import { QuoteProvider } from './stores/create-quote/quote-store';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'devextreme/dist/css/dx.light.css';
import './common/styles/global.scss';
import './app.scss';
import {
  applyCustomAccent,
  getCustomAccent
} from './common/themes/theme-color-utils';

export default function App() {
  const [selectedLanguage] = useCustomerPortalGlobalStore(
    store => store.store.selectedLanguage
  );
  const [selectedTheme] = useCustomerPortalGlobalStore(
    store => store.store.selectedTheme
  );
  //const { changeLanguage } = useDispatchActions();
  const { isLoading, loginWithRedirect, user, error } = useAuth0();

  useEffect(() => {
    (async function login() {
      if (!isLoading && !user) {
        await loginWithRedirect();
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  useEffect(() => {
    const theme = selectedTheme === 'dark' ? 'dark' : 'light';
    document.documentElement.dataset.theme = theme;
    localStorage.setItem('selectedTheme', theme);
    applyCustomAccent(getCustomAccent(), theme);
  }, [selectedTheme]);

  return (
    <div>
      <ErrorBoundary componentName="customer-portal">
        <I18nProvider languageKey={selectedLanguage}>
          <OrderProvider>
            <BolOrderProvider>
              <QuoteProvider>
                <SettingsMenuProvider>
                  {!user ? <></> : <Layout />}
                </SettingsMenuProvider>
              </QuoteProvider>
            </BolOrderProvider>
          </OrderProvider>
        </I18nProvider>
      </ErrorBoundary>
    </div>
  );
}
